export default {
  'notifications.actionItems': 'Action Items',
  'notifications.allCaughtUp': 'You are all caught up!',
  'notifications.awaitingApproval': 'Awaiting Approval',
  'notifications.bulletins': 'To Read',
  'notifications.messageOfTheDay': 'message of the day',
  'notifications.noItems': 'No Action Items!',
  'notifications.needYourReview': 'need your review',
  'notifications.toApprove': 'To Approve',
  'notifications.viewMoreInformation': 'View more information',
  'notifications.viewLessInformation': 'View less information',
  'notifications.viewActionItemToRead': 'View <%= title %> <%= message %>'
};
